export default "<app-navbar></app-navbar>\n<div>\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n"